import { Box, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DashboardContainer } from 'src/containers/dashboard';
import { Helmet } from 'react-helmet';
import useSettings from '../hooks/useSettings';

const Dashboard = () => {
  const { t } = useTranslation();
  const { settings } = useSettings();
  return (
    <>
      <Helmet>
        <title>{t('users.helmet')}</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 4
        }}
      >
        <Container maxWidth={settings.compact ? 'xxl' : false}>
          <Box sx={{ mt: 3 }}>
            <DashboardContainer />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Dashboard;
